import { AlertDialogTrigger, AlertDialogContent, AlertDialogHeader, AlertDialogTitle, AlertDialogDescription, AlertDialog } from "../ui/alert";
import { memo } from "react";
interface AlertProps {
    title: string;
    description: string;
    showButton: React.ReactNode;
    children: React.ReactNode;
    open: boolean;
}

const AlertComponent = ({ title, description, showButton, children, open }: AlertProps) => {
    return (
        <AlertDialog
            open={open}
        >
            {showButton && (
                <AlertDialogTrigger asChild>
                    {showButton}
                </AlertDialogTrigger>
            )}
            <AlertDialogContent className="bg-white rounded-lg shadow-lg">
                <AlertDialogHeader>
                    <AlertDialogTitle>{title}</AlertDialogTitle>
                    <AlertDialogDescription>{description}</AlertDialogDescription>
                </AlertDialogHeader>
                <div className="flex items-center gap-2">
                    {children}
                </div>
            </AlertDialogContent>
        </AlertDialog>
    )
}

export default memo(AlertComponent);